import AI_ICON from "@assets/quick-news/ai-icon.svg";
import CHEVRON_LEFT from "@assets/quick-news/Chevron_left_grey.svg";
import { QN_ANALYTICS_EVENT_BASE } from "@config/QuickNewsConstants";
import { useTablaCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useTablaCustomEventAnalyticsCall";
import Cookies from "js-cookie";
import { ReactElement, useCallback } from "react";
import { twMerge } from "tailwind-merge";

import { QnHelpBtn } from "./QnHelpBtn";

// Navigation button styles
const NAV_BUTTON_STYLES = {
  base: "relative z-10 h-full flex-1 text-[14px] font-medium text-neutral-300 py-1 overflow-hidden",
  underline: "before:absolute before:bottom-0 before:bg-white before:h-0.5",
} as const;

// AI Icon styles
const AI_ICON_STYLES = {
  base: "inline-block relative top-[-8px]",
  active: "opacity-100",
  inactive: "opacity-30",
} as const;

export default function QnTopNav(): ReactElement {
  const tablaCustomEvent = useTablaCustomEventAnalyticsCall();
  const goBackClick = useCallback(() => {
    const qnRedirectUrl = Cookies.get("qnRedirectUrl");
    tablaCustomEvent({
      ...QN_ANALYTICS_EVENT_BASE,
      clickAction: "back",
      clickLabel: "home",
    });

    if (qnRedirectUrl) {
      window.location.href = decodeURIComponent(qnRedirectUrl);
    } else {
      // history.back();
      window.location.href = "/";
    }
  }, [tablaCustomEvent]);

  return (
    <header className="qn-header z-40 w-full h-[45px] md:mt-10 top-0 bg-transparent px-[15px]">
      <div className="relative mx-auto w-full flex items-center justify-center gap-2">
        <button
          aria-label="Go back"
          onClick={goBackClick}
          className="md:absolute left-4 w-[45px] p-2"
        >
          <img height={24} width={24} alt="Go back" src={CHEVRON_LEFT} />
        </button>

        <nav className="qn-header-nav flex items-center justify-center h-[45px] w-[calc(100%-45px)] md:w-[450px] my-1">
          <button
            key={"MyFeed"}
            className={twMerge(
              NAV_BUTTON_STYLES.base,
              // NAV_BUTTON_STYLES.underline,
              "before:right-0 before:origin-right",
              "font-bold text-white before:w-full",
            )}
          >
            <div className="inline-block font-opensans">MyFeed</div>

            <div
              className={twMerge(AI_ICON_STYLES.base, AI_ICON_STYLES.active)}
            >
              <img src={AI_ICON} alt="AI Icon" className="ml-1 w-[11px]" />
            </div>
          </button>
        </nav>

        <QnHelpBtn />
      </div>
    </header>
  );
}
